import { react, useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Image from 'mui-image';
import { Link } from 'react-router-dom';
import './Navbar.css'
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import MailIcon from '@mui/icons-material/Mail';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import LoginIcon from '@mui/icons-material/Login';



export default function NavbarNoUser(props) {
    const [state, setState] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const [navLink, setNavLink] = useState('Home');

    function navClicked(path) {
        setNavLink(path);
        window.location = window.location.origin + '/' + path;
    };

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const createMenuList = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List>
                <ListItem component={Link} key={'MenuLinkHome'} to='/Pickup' onClick={() => navClicked('Pickup')} className={navLink == 'Pickup' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <HomeIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Pickup my Cans'} />
                    </ListItemButton>
                </ListItem>
                <ListItem component={Link} key={'MenuLinkAbout'} to='/About' onClick={() => navClicked('About')} className={navLink == 'About' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <InfoIcon />
                        </ListItemIcon>
                        <ListItemText primary={'About'} />
                    </ListItemButton>
                </ListItem>
                <ListItem component={Link} key={'MenuLinkContactUs'} to='/ContactUs' onClick={() => navClicked('ContactUs')} className={navLink == 'ContactUs' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <MailIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Contact Us'} />
                    </ListItemButton>
                </ListItem>
                <ListItem component={Link} key={'MenuLinkMedia'} to='/Media' onClick={() => navClicked('Media')} className={navLink == 'Media' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <LiveTvIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Media/Partnerships'} />
                    </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem component={Link} key={'MenuLinkSignUp'} to='/SignUp' onClick={() => navClicked('SignUp')} className={navLink == 'SignUp' ? 'NavLinkSelected' : 'NavLink'} disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <DirectionsCarIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Become a Driver'} />
                    </ListItemButton>
                </ListItem>
                <ListItem key={'Menu-DriverLogin'} component={Link} to='/' disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <LoginIcon />
                        </ListItemIcon>
                        <ListItemText primary={'Driver Login'} />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );

    return (
        <div>
            <Drawer open={state['left']} onClose={toggleDrawer('left', false)} >
                {createMenuList('left')}
            </Drawer>
            <AppBar position="static">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={toggleDrawer('left', true)}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                        </Box>


                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            <Button
                                component={Link}
                                onClick={() => navClicked('Pickup')}
                                to='/Pickup'
                                key={'NavLinkPickup'}
                                sx={
                                    {
                                        my: 2,
                                        display: 'block'
                                    }
                                }
                                className={navLink == 'Pickup' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                Pickup My Cans
                            </Button>
                            <Button
                                component={Link}
                                onClick={() => navClicked('About')}
                                to='/About'
                                key={'NavLinkAbout'}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'About' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                About
                            </Button>
                            <Button
                                component={Link}
                                to='/ContactUs'
                                key={'NavLinkContactUs'}
                                onClick={() => navClicked('ContactUs')}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'ContactUs' ? 'NavLinkSelected' : 'NavLink'}
                            >Contact Us
                            </Button>
                            <Button
                                component={Link}
                                to='/Media'
                                key={'NavLinkMedia'}
                                onClick={() => navClicked('Media')}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'Media' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                Media/Partnerships
                            </Button>
                            <Button
                                component={Link}
                                to='/SignUp'
                                key={'NavLinkSignUp'}
                                onClick={() => navClicked('SignUp')}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'SignUp' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                Become a Driver
                            </Button>
                            <Button
                                component={Link}
                                to='/'
                                key={'NavLinkLogin'}
                                onClick={() => navClicked('Login')}
                                sx={{ my: 2, display: 'block' }}
                                className={navLink == 'Login' ? 'NavLinkSelected' : 'NavLink'}
                            >
                                Driver Login
                            </Button>
                            {/*<Button*/}
                            {/*    component={Link}*/}
                            {/*    to='/Order'*/}
                            {/*    key={'NavLinkOrder'}*/}
                            {/*    onClick={() => navClicked('Order')}*/}
                            {/*    sx={{ my: 2, display: 'block' }}*/}
                            {/*    className={navLink == 'Order' ? 'NavLinkSelected' : 'NavLink'}*/}
                            {/*>*/}
                            {/*    Order*/}
                            {/*</Button>*/}
                        </Box>
                        <Image src="images/Sipzee white TM.png" width={128} height={50} />
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    );
}
